import React, { useState } from 'react';
import { Button, Card, ConfigProvider, Flex, Modal, Space } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import ProjectDisplay from './ProjectDisplay.js';

import tttPage1 from '../../images/projects/tictracktoe/page1.png';
import tttPage2 from '../../images/projects/tictracktoe/page2.png';
import tttPage3 from '../../images/projects/tictracktoe/page3.png';
import tttPage4 from '../../images/projects/tictracktoe/page4.png';
import tttPage5 from '../../images/projects/tictracktoe/page5.png';
import tttPage6 from '../../images/projects/tictracktoe/page6.png';
import tttPage7 from '../../images/projects/tictracktoe/page7.png';
import tttPage8 from '../../images/projects/tictracktoe/page8.png';

import researchPage1 from '../../images/projects/recherche/page1.png';
import researchPage2 from '../../images/projects/recherche/page2.png';
import researchPage3 from '../../images/projects/recherche/page3.png';
import researchPage4 from '../../images/projects/recherche/page4.png';
import researchPage5 from '../../images/projects/recherche/page5.png';
import researchPage6 from '../../images/projects/recherche/page6.png';

import searchEnginePage from '../../images/projects/recherche_image/page.png';
import FolderItem from './FolderItem.js';

const titles = [
  {name: "TIC-TRACK-TOE", id: 0},
  {name: "Research project", id: 1},
  {name: "Image search engine", id: 2},
];

const Projects = ({setIsModalOpen, isModalOpen}) => {

  const [displayIndex, setDisplayIndex] = useState(-1);
  const [lastVisited, setLastVisited] = useState(-1);

  const tttCard = <Card style={{
    width: '100%',
    height: 'auto'
  }}>
    <p>
    Tic-Track-Toe is the first web game I coded, is a strategy game that challenges players to connect artists based on their collaborations.<br /><br />
    In Single Player mode, the Daily Challenge requires filling a Tic-Tac-Toe grid where each row and column must feature an artist who has collaborated with both axes, with limited chances for mistakes.<br /><br />
    The Link the Artists challenge tests your knowledge by having you name an artist who has worked with two given artists.<br /><br />
    In Head-to-Head mode, players compete across genres like RAP FR, UK RAP, US RAP, VARIÉTÉ, POP, and CUSTOM, claiming grid cells by correctly identifying linked artists.<br /><br />
    A unique blend of music trivia and tactical gameplay, Tic-Track-Toe puts your collaboration knowledge to the test!<br /><br />
    </p>
  </Card> ;

  const researchCard = <Card style={{
    width: '100%',
    height: 'auto'
  }}>
    <p>
    This is a custom-built interface that I meticulously designed and developed to interactively manipulate, visualize, and analyze complex graph structures, with a particular focus on the collaboration network within the L3i Laboratory at the University of La Rochelle.<br /><br />  
    The L3i Laboratory at the University of La Rochelle is characterized by strong collaboration among its members, shaped by the diversity of their research projects. This project aims to map these interactions through co-publications, offering a comprehensive view of collaboration dynamics within the laboratory.<br /><br />
    This initiative is part of a project given in the subject “Découverte de la recherche - Projet scientifique”, an exploratory approach to studying and understanding how these collaborations evolve over time, and if the three current teams can be redivided according to the communities detected. In the future, the insights gained may contribute to Mr. Waffo Kemgne’s PhD research.<br /><br />
    </p>
  </Card>;

  const engineCard = <Card style={{
    width: '100%',
    height: 'auto'
  }}>
    <p>
    In this project, I developed a MATLAB-based image retrieval system that leverages color histograms and distance metrics to identify similar images.<br /><br />
    The system extracts and processes color histograms from images, then applies Euclidean and cosine distances to compare them.<br /><br />
    To enhance performance, I implemented utility functions for vector manipulation and similarity measurement.<br /><br />
    Additionally, I designed an interactive MATLAB interface using App Designer, allowing users to select images, adjust parameters, and retrieve the most similar images from a dataset.<br /><br />
    The results demonstrated that Euclidean distance provided more distinct separations between images, highlighting its effectiveness in capturing visual similarity.<br /><br />
    </p>
  </Card>;

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleDoubleClick = (e) => {
    setDisplayIndex(e);
    if (e !== -1) {
      setLastVisited(e);
    }
  };

  const handleRightArrowClick = () => {
    setDisplayIndex(lastVisited);
  };

  const title = 
    <Flex align='center'>
      <Button disabled={displayIndex === -1} shape='circle' type='text' onClick={() => handleDoubleClick(-1)} icon={<LeftOutlined />} />
      <Button disabled={lastVisited === -1 || displayIndex !== -1} shape='circle' type='text' onClick={handleRightArrowClick} icon={<RightOutlined />} />
      {displayIndex === -1 ? 'My Projects' : titles[displayIndex].name}
    </Flex>
  ;

  const pages = [
    {
      presentation: tttCard,
      slides: [tttPage1, tttPage2, tttPage3, tttPage4, tttPage5, tttPage6, tttPage7, tttPage8],
      link: null
    },
    {
      presentation: researchCard,
      slides: [researchPage1, researchPage2, researchPage3, researchPage4, researchPage5, researchPage6],
      link: null
    },
    {
      presentation: engineCard,
      slides: [searchEnginePage],
      link: 'https://drive.google.com/file/d/15joSL8SrUWAj3NFHHNkB4z8iSSFlMfsB/view?usp=sharing'
    }
  ];

  return (
    <ConfigProvider
      theme={{
        components: {
          Modal: {
            contentBg: '#262626',
            headerBg: '#262626',
            titleFontSize: 24
          },
          Button: {
            colorTextDisabled: '#3A3A3A',
          },
          Card: {
            colorBgContainer: '#171717'
          }
        },
        token: {
          colorText: 'white',
          fontSizeLG: 24,
          colorIcon: 'white',
          colorIconHover:'#CCCCCC'
        },
      }}
    >
      <Flex align="center" justify="center">
        <Modal 
          title={title} 
          centered 
          open={isModalOpen} 
          footer={null} 
          onCancel={handleCancel} 
          width={{
            xs: '90%',
            sm: '80%',
            md: '70%',
            lg: '60%',
            xl: '50%',
            xxl: '40%',
          }}
        >
          {displayIndex === -1 ? (
            window.innerWidth < 768 ? (
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, 1fr)", // 2 columns
                  gap: "20px", // Spacing between items
                  paddingTop: "50px",
                  placeItems: "center",
                }}
              >
                {titles.map((p, index) => (
                  <FolderItem
                    key={index}
                    id={p.id}
                    folderName={p.name}
                    width={100}
                    onDoubleClick={handleDoubleClick}
                  />
                ))}
              </div>
            ) : (
              <Space size='large' style={{ paddingTop: 50, paddingBottom: 200 }}>
                {titles.map((p, index) => (
                  <FolderItem
                    key={index}
                    id={p.id}
                    folderName={p.name}
                    width={100}
                    onDoubleClick={handleDoubleClick}
                  />
                ))}
              </Space>
            )
          ) : (
            <ProjectDisplay
              pages={pages[displayIndex].slides}
              presentation={pages[displayIndex].presentation}
              link={pages[displayIndex].link}
            />
          )}
        </Modal>
      </Flex>
    </ConfigProvider>
  );
};

export default Projects;

